module.exports = __webpack_public_path__ + "img/1.13fc531d.jpg";